import iconTemplate from '~/components/icons/IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Delete-Circle--Streamline-Flex"
    >
        <desc>
            {
                '\n    Delete Circle Streamline Icon: https://streamlinehq.com\n  '
            }
        </desc>
        <g id="delete-circle--button-delete-remove-add-circle-buttons-cross-x-mathematics-multiply-math">
            <g id="Group 5625">
                <path
                    id="Vector 1179"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m9.53174 4.46875 -5.0625 5.0625"
                    strokeWidth={1}
                />
                <path
                    id="Vector 1180"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m9.53174 9.53125 -5.0625 -5.0625"
                    strokeWidth={1}
                />
            </g>
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 13.5c4.16 0 6.5 -2.34 6.5 -6.5S11.16 0.5 7 0.5 0.5 2.84 0.5 7s2.34 6.5 6.5 6.5Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
